import { ConflictStore } from "sh-conflict-store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_CONFLICT_COUNT_EXCEEDED_LIMITS', function setConflictCountExceededLimits(didConflictCountExceedLimit: boolean) {
   ConflictStore().didConflictCountExceedLimit = didConflictCountExceedLimit;
});
